import { MenuItem } from './model';

export const MENU_ITEMS: ReadonlyArray<MenuItem> = [
  {
    enabled: false,
    name: 'Программа',
    url: 'program',
    scrollToElement: undefined,
    showOnDesktop: true,
    showInFooter: true,
    showOnMobile: true,
  },
  {
    enabled: true,
    name: 'Эксперты 2026',
    url: 'experts',
    scrollToElement: undefined,
    showOnDesktop: true,
    showInFooter: true,
    showOnMobile: true,
  },
  {
    enabled: true,
    name: 'Экспозиция 2026',
    scrollToElement: 'exhibitors',
    showOnDesktop: true,
    showInFooter: true,
    showOnMobile: true,
  },
  {
    enabled: true,
    name: 'Партнеры 2026',
    scrollToElement: 'partners',
    showOnDesktop: true,
    showInFooter: true,
    showOnMobile: true,
  },
  {
    enabled: true,
    name: 'Место проведения',
    scrollToElement: 'location',
    showOnDesktop: true,
    showInFooter: true,
    showOnMobile: true,
  },
  {
    enabled: true,
    name: 'Новости',
    url: 'news',
    scrollToElement: undefined,
    showOnDesktop: true,
    showInFooter: true,
    showOnMobile: true,
  },
  {
    enabled: true,
    name: 'Как это было',
    scrollToElement: undefined,
    showOnDesktop: true,
    showInFooter: true,
    showOnMobile: true,
    url: 'gallery',
  },
  {
    enabled: true,
    name: 'Фотобудка',
    scrollToElement: undefined,
    showOnDesktop: false,
    showInFooter: false,
    showOnMobile: true,
    url: 'photobooth',
  },
  {
    enabled: false,
    isLink: true,
    name: 'Где жить',
    scrollToElement: undefined,
    showOnDesktop: true,
    showInFooter: true,
    showOnMobile: true,
    url: 'https://disk.yandex.ru/i/FLC3WY87pMoJTw',
  },
  {
    enabled: false,
    isLink: true,
    name: 'ПРЕМИЯ «ШЕФ-ПОВАР ГОДА»',
    scrollToElement: undefined,
    showOnDesktop: true,
    showInFooter: false,
    showOnMobile: true,
    url: 'https://awards.bestchefs.ru/',
  },
] as const;
